@if (loading) {
<span class="spinner" role="status" aria-live="polite" aria-busy="true">
	<i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
	<p>Loading…</p>
</span>
}
<router-outlet></router-outlet>
